export default __webpack_public_path__ + "static/media/bannerMobile.90c2cffb.jpg";